import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import NewHome from './NewPages/HomePage/Home'
import reportWebVitals from "./reportWebVitals";
import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter as Router, Route, Routes, useLocation, Navigate, Outlet } from "react-router-dom";
// import Login from "./pages/Login";
import { Provider } from "react-redux";
import store from "./store/Store.js";
// import Loginmain from "./pages/Loginmain.js";
import RedirectProject from "./NewPages/RedirectProject.js";
import DocumentationMD from "./NewPages/DocumenatationMD.js";
import StyleDocs from "./NewPages/StyleDocs.js";
import Admin from "./NewPages/Admin.js";
import NewLoginPage from "./NewPages/Loginnew.js";
import Signup from "./NewPages/Signup";
import NewTemplates from "./NewPages/Templates/Templates.js"
import NewDashboard from "./NewPages/Dashboard.js";
import NewProjectdisplay from "./NewPages/Dashboardcomponents/Projectdisplay.js";
import { ThemeProvider } from "./Themes/ThemeContext.jsx";
import ContactUs from "./NewPages/Contactus/ContactUs";
import Presentation from "./NewPages/Presentation/Presentation.js";
const root = ReactDOM.createRoot(document.getElementById("root"));
// https://medium.com/@deepankaracharyya/deploying-a-django-app-with-apache-mod-wsgi-windows-e9712dc07bba
window.global = {
  // server_url: "https://" + window.location.hostname + ":8443",
  // server_url: "https://editlatex.transforma.in:8443/",
  // server_url: "http://10.10.10.46/editlatex_django/",
  // server_url: "http://10.10.10.57:8001/"
  server_url: "https://editlatex-dev.transforma.in:8444/"
  // server_url: "http://192.168.1.17:8444/"
  // server_url: "http://localhost:8000/"
};
var base_path = "";
if (process.env.REACT_APP_STAGE === "webpage") {
  base_path = "";
}
export const config = "newDesign"
const PublicRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? <Navigate to="/dashboard/myprojects" replace /> : children;
};
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const location = useLocation();
  return token
    ? children
    : <Navigate to={`/loginnew/signIn?redirect=${location.pathname}`} replace />;
};
root.render(
  <Provider store={store}>
    <ThemeProvider>
      <ChakraProvider toastOptions={{ defaultOptions: { position: "top" } }}>
        {/* <React.StrictMode> */}
        <Router basename={base_path}>
          <Routes>
            <Route
              path="/"
              element={
                // <PublicRoute>
                <Navigate to="/home" />
                // </PublicRoute>
              }
            />
            <Route path="/home" element={<NewHome />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/home/:page" element={<NewHome />} />
            <Route path="/:projectid" element={<RedirectProject />} />
            <Route path="/:projectid/:file" element={<App />} />
            {/* <Route path="/login/" element={<Login />} /> */}

            <Route path="/presentation" element={<Presentation />} />

            <Route path="/docs" element={<DocumentationMD />} />
            <Route path="/docs/styles" element={<StyleDocs />} />


            <Route path="/admin" element={
              <PrivateRoute>
                <Admin />
              </PrivateRoute>
            } />

            <Route path="/loginnew/:loginpages" element={<PublicRoute>
              <NewLoginPage />
            </PublicRoute>}>
              <Route path=":action" element={<PublicRoute>
                <NewLoginPage />
              </PublicRoute>} />
            </Route>
            <Route path="/signup" element={<PublicRoute>
              < Signup />
            </PublicRoute>}>
            </Route>

            <Route path="/signin" element={<PublicRoute>
              <NewLoginPage />
            </PublicRoute>}>
            </Route>


            <Route path="/dashboard" element={<NewDashboard />}>
              <Route path=":project" element={<NewProjectdisplay />} />
            </Route>

            <Route path="/templates/:subcat?/:singletemp?" element={<NewTemplates />} />
          </Routes>
        </Router>
        {/* </React.StrictMode> */}
      </ChakraProvider>
    </ThemeProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
